import {
  Button,
  createTableColumn,
  TableCellLayout,
  TableColumnDefinition,
  Theme,
  Tooltip,
} from "@fluentui/react-components";
import {
  Edit20Regular,
  Delete20Regular,
  Tag20Regular,
  TagMultiple20Regular,
} from "@fluentui/react-icons";
import { ReactComponent as ActivateIcon } from "../../../assets/connect-accounted-companies-control-icons/activate.svg";
import { ReactComponent as InactivateIcon } from "../../../assets/connect-accounted-companies-control-icons/inactivate.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/connect-accounted-companies-control-icons/delete.svg";
import { formatDate } from "../../../utils/HelperFunctions";
import { KS_customerservice_Service_Clients_M2MConnector_UserDto as M2M } from "../../../CustomerSvcService";

export const tableColsSizes = {
  taxNumber: {
    minWidth: 120,
    defaultWidth: 250,
  },
  companyId: {
    minWidth: 120,
    defaultWidth: 250,
  },
  timestamp: {
    minWidth: 120,
    defaultWidth: 500,
  },
};

const styles = `
  .table__control-buttons_container {
    display: flex; flex-direction: row; width: 100%;
    justify-content: space-between; justify-items: center;
    width: ${tableColsSizes.timestamp.defaultWidth}px;
  }
  button {
    all: unset;
    appearance: none;
    border: none;
    background: none;
    box-shadow: none;
    margin: 0;
    padding: 0;
    font: inherit;
    color: inherit;
    line-height: normal;
    cursor: pointer;
    font-size: 16px;
  }
  .table__control-buttons_row {
    display: flex; 
    flex-direction: row;
    gap: 4px;
  }
`;

const handleRowAction = async (
  action: string | null | undefined,
  m2mCompanyEntry?: M2M,
) => {
  /*   switch (action) {
    case "activate":
      // TODO: aktiválási logika ide
      const ok1 = window.confirm(
        `Biztosan aktiválni szeretnéd ${m2mCompanyEntry?.companyName} céget?`,
      );
      if (!ok1) {
        return;
      } else {
        console.log("activate", m2mCompanyEntry);
      }
      break;
    case "inactivate":
      // TODO: deaktiválási logika ide
      const ok2 = window.confirm(
        `Biztosan inaktiválni szeretnéd ${m2mCompanyEntry?.companyName} céget?`,
      );
      if (!ok2) {
        return;
      } else {
        console.log("inactivate", m2mCompanyEntry);
      }
      break;
    case "delete":
      // delete case is handled below
      const ok3 = window.confirm(
        `Biztosan törölni szeretnéd ${m2mCompanyEntry?.companyName} céget?`,
      );
      if (!ok3) {
        return;
      } else {
        console.log("delete", m2mCompanyEntry);
      }
      break;
    default:
      return;
  } */
};

const ControlButtons = (m2mCompanyEntry: M2M) => {
  return (
    <></>
    /*    <div className="table__control-buttons_row">
      <button onClick={() => handleRowAction("activate", m2mCompanyEntry)}>
        <ActivateIcon />
      </button>
      <button onClick={() => handleRowAction("inactivate", m2mCompanyEntry)}>
        <InactivateIcon />
      </button>
      <button onClick={() => handleRowAction("delete", m2mCompanyEntry)}>
        <DeleteIcon />
      </button>
    </div> */
  );
};

export const getColumnsForM2M = (theme: Theme) =>
  [
    createTableColumn<M2M>({
      columnId: "taxNumber",
      renderHeaderCell: () => "Adószám",
      renderCell: (m2mCompanyEntry: M2M) => {
        return (
          <TableCellLayout truncate>
            {m2mCompanyEntry.taxPayerId ?? ""}
          </TableCellLayout>
        );
      },
    } as TableColumnDefinition<M2M>),
    createTableColumn<M2M>({
      columnId: "companyId",
      renderHeaderCell: () => "Company Id",
      renderCell: (m2mCompanyEntry: M2M) => {
        return (
          <TableCellLayout truncate>
            {m2mCompanyEntry.companyId ?? ""}
          </TableCellLayout>
        );
      },
    } as TableColumnDefinition<M2M>),

    createTableColumn<M2M>({
      columnId: "timestamp",
      renderHeaderCell: () => "Bekötés dátuma",
      renderCell: (m2mCompanyEntry: M2M) => {
        return (
          <>
            <style>{styles}</style>
            <TableCellLayout
              truncate
              //className="table__control-buttons_container"
            >
              <div className="table__control-buttons_container">
                {formatDate(m2mCompanyEntry.createdAt) ?? ""}
              </div>
            </TableCellLayout>
          </>
        );
      },
    } as TableColumnDefinition<M2M>),
  ] as TableColumnDefinition<M2M>[];
